import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import {
  PmdNavbarModule,
  PmdSidebarModule,
  PmdCollapseModule,
  PmdDropdownModule,
  PmdFormGroupModule,
  PmdButtonModule,
  PmdCardModule,
  PmdSwitchModule,
  PmdAccordionModule,
  PmdCheckboxModule,
  PmdTooltipModule,
  PmdAlertModule,
  PmdRippleEffectModule,
  PmdModalModule,
  PmdRadioButtonModule,
  PmdButtonToggleModule,
  PmdTabsModule,
  PmdPopoverModule,
  PmdProgressbarModule,
  NgSelectModule,
  BsDatepickerModule,
  RatingModule,
} from '@shared/propeller';
import {
  DebounceDirective,
  ScrollTrackerDirective,
  SkipContentDirective,
} from '@shared/directives';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { LanguageComponent } from './language/language.component';
import { LoaderComponent } from './loader/loader.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PasswordStrengthComponent } from './password-strength/password-strength.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { DataNotFoundComponent } from './data-not-found/data-not-found.component';
import { TableLoaderComponent } from './table-loader/table-loader.component';
import { UserCardComponent } from './user-card/user-card.component';
import { CourseCardComponent } from './course-card/course-card.component';
import { GameCardComponent } from './game-card/game-card.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    DebounceDirective,
    FooterComponent,
    HeaderComponent,
    LanguageComponent,
    LoaderComponent,
    TableLoaderComponent,
    NavbarComponent,
    NotFoundComponent,
    DataNotFoundComponent,
    PasswordStrengthComponent,
    ScrollTrackerDirective,
    SidebarComponent,
    SkipContentDirective,
    UserCardComponent,
    CourseCardComponent,
    GameCardComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgSelectModule,
    TranslateModule.forChild(),
    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule.forRoot(),
    PmdDropdownModule.forRoot(),
    PmdFormGroupModule.forRoot(),
    PmdPopoverModule.forRoot(),
    PmdButtonModule,
    PmdTabsModule.forRoot(),
    PmdSwitchModule,
    PmdAccordionModule.forRoot(),
    PmdCheckboxModule,
    PmdTooltipModule.forRoot(),
    PmdAlertModule.forRoot(),
    PmdRippleEffectModule,
    PmdModalModule.forRoot(),
    PmdButtonToggleModule.forRoot(),
    PmdRadioButtonModule,
    PmdProgressbarModule.forRoot(),
    RatingModule.forRoot(),
    // PmdDatepickerModule.forRoot(),
    BsDatepickerModule.forRoot(),
  ],
  exports: [
    CommonModule,
    FormsModule,
    NgSelectModule,
    RouterModule,
    ReactiveFormsModule,
    TranslateModule,

    BreadcrumbComponent,
    DebounceDirective,
    FooterComponent,
    HeaderComponent,
    LanguageComponent,
    LoaderComponent,
    TableLoaderComponent,
    NavbarComponent,
    NotFoundComponent,
    DataNotFoundComponent,
    PasswordStrengthComponent,
    ScrollTrackerDirective,
    SidebarComponent,
    SkipContentDirective,
    UserCardComponent,
    CourseCardComponent,
    GameCardComponent,

    PmdNavbarModule,
    PmdSidebarModule,
    PmdCardModule,
    PmdCollapseModule,
    PmdDropdownModule,
    PmdFormGroupModule,
    PmdButtonModule,
    PmdTabsModule,
    PmdSwitchModule,
    PmdAccordionModule,
    PmdCheckboxModule,
    PmdTooltipModule,
    PmdAlertModule,
    PmdPopoverModule,
    PmdRippleEffectModule,
    PmdModalModule,
    PmdButtonToggleModule,
    PmdRadioButtonModule,
    PmdProgressbarModule,
    RatingModule,
    // PmdDatepickerModule,
    BsDatepickerModule,
  ],
  providers: [],
})
export class SharedModule {}
